import React from "react"
import CommonUtils from "@bodeboca/utils"

const SizePrice = ({price, strikethrough}) => {
  return (<span className="uc-price" data-price={price}>
    {strikethrough && <span className="strikethrough"/>}
    <span>{CommonUtils.euro(price)}</span>
    <small>,{CommonUtils.cent(price)}</small>
    <small> €</small>
  </span>)
}
export default SizePrice
